export function isEditable(state) {
    return state === "draft" || state === "published";
}

export function isLivEditable(state) {
    return state === "draft" || state === "paused";
}

export function isPreLaunchable(state) {
    return state === "draft" || state === "paused";
}

export function isStartedOrFinished(state) {
    return state === "active" || state === "finished" || state === "paused";
}

export function isFinishedOrActive(state) {
    return state === "active" || state === "finished";
}

export function isPreviewable(state) {
    return state === "draft";
}

export function isCopyableUrl(state) {
    return state === "published" || state === "active";
}

export function isPausable(state) {
    return state === "active" || state === "published";
}

export function isResumable(state) {
    return state === "paused";
}

export function isRestartable(state) {
    return state === "finished";
}

export function canEditStartDate(state, instantActive) {
    if (instantActive) return false;
    return !(
        state === "active" ||
        state === "finished" ||
        state === "paused"
    );
}

export function canEditEndDate(state) {
    return !(
        state === "active" ||
        state === "finished"
    );
}

export function shouldDeleteStartDateOnSave(state) {
    return state === "paused";
}

export function canShowInstantActiveCheckbox(state) {
    return state === "draft" || state === "published" || state === "paused";
}
